<script setup lang="ts">
import { useTutorApplicationStore } from '../model/store'
import FormBox from './FormBox.vue'
import AcceptEmailDelivery from './legal-agreements/AcceptEmailDelivery.vue'
import AcceptConfidentiality from './legal-agreements/AcceptConfidentiality.vue'
import AcceptNotRestrictedResident from './legal-agreements/AcceptNotRestrictedResident.vue'
import AcceptDataProcessingTerms from './legal-agreements/AcceptDataProcessingTerms.vue'

defineOptions({
  name: 'LegalAgreements',
})

const tutorApplicationStore = useTutorApplicationStore()

const setClear = (): void => {
  tutorApplicationStore.resetLegalAgreements()
}

</script>

<template>
  <FormBox
    title="Legal Agreements"
    @click:clear="setClear"
  >
    <div class="legal-agreements__fields">
      <AcceptEmailDelivery />
      <AcceptConfidentiality />
      <AcceptNotRestrictedResident />
      <AcceptDataProcessingTerms />
    </div>
  </FormBox>
</template>

<style scoped lang="scss" src="./LegalAgreements.scss" />
